<div class="grid">
    <div class="col-12">
        <form>
            <p-card [header]="'REGISTER_NEW_USER' | translate">
                <p-messages [(value)]="messages" [closable]="true" />
                <div class="p-fluid p-formgrid grid" [formGroup]="userForm">
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="firstname" class="text-sm text-500">{{
                            "FIRST_NAME" | translate
                        }}</label>
                        <input
                            type="text"
                            id="firstname"
                            [placeholder]="'FIRST_NAME' | translate"
                            pInputText
                            formControlName="firstName"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="surname" class="text-sm text-500">{{
                            "LAST_NAME" | translate
                        }}</label>
                        <input
                            type="text"
                            id="surname"
                            [placeholder]="'LAST_NAME' | translate"
                            pInputText
                            formControlName="lastName"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="email" class="text-sm text-500">{{
                            "EMAIL" | translate
                        }}</label>
                        <input
                            type="text"
                            id="email"
                            [placeholder]="'EMAIL' | translate"
                            pInputText
                            formControlName="email"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="password" class="text-sm text-500">{{
                            "PASSWORD_PLACEHOLDER" | translate
                        }}</label>
                        <input
                            type="text"
                            id="password"
                            [placeholder]="'PASSWORD_PLACEHOLDER' | translate"
                            pInputText
                            formControlName="password"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label
                            htmlFor="repeatPassword"
                            class="text-sm text-500"
                            >{{
                                "REPEAT_PASSWORD_PLACEHOLDER" | translate
                            }}</label
                        >
                        <input
                            type="text"
                            id="repeatPassword"
                            [placeholder]="
                                'REPEAT_PASSWORD_PLACEHOLDER' | translate
                            "
                            pInputText
                            formControlName="repeatPassword"
                        />
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="availableUserGroups.length > 0"
                    >
                        <label htmlFor="role" class="text-sm text-500">{{
                            "USER_ROLE" | translate
                        }}</label>
                        <p-dropdown
                            [options]="availableUserGroups"
                            optionLabel="name"
                            optionValue="value"
                            [placeholder]="'USER_ROLE' | translate"
                            formControlName="group"
                            [placeholder]="'SELECT_USER_GROUP' | translate"
                        >
                        </p-dropdown>
                    </div>
                </div>
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2 mt-1">
                        <p-button
                            icon="pi pi-arrow-left"
                            pRipple
                            (click)="back()"
                            [label]="'BACK' | translate"
                            severity="danger"
                        />
                        <p-button
                            icon="pi pi-times-circle"
                            pRipple
                            (click)="clearForm()"
                            [label]="'CLEAR' | translate"
                            severity="secondary"
                        />

                        <button
                            icon="pi pi-check"
                            [label]="'SAVE' | translate"
                            severity="success"
                            (click)="registerUserClicked()"
                            [disabled]="!userForm.valid"
                            pButton
                            pRipple
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </form>
    </div>
</div>
